import React from 'react';
import { unverifiedPurchaserCheckList } from '../../../constants/constants';
import { List } from '../../common/List/List';

export default function UnverifiedPurchaser() {
  return <List variant="sm" list={unverifiedPurchaserCheckList} />;
}
